import Cookies from "js-cookie";

export const removeAccessToken = (): void => {
    Cookies.remove("accessToken");
};

export const removeRefreshToken = (): void => {
    Cookies.remove("refreshToken");
};
